export default function (number: number | string | undefined | null): undefined | null | number {
  if (!number) return 0;
  let tmp = number;
  if (typeof tmp === 'string') tmp = parseFloat(tmp);
  return parseFloat(tmp.toFixed(2));
}
